module.exports = __webpack_public_path__ + "static/media/compliance-and-risks.f0855282.png";